import { useEffect } from 'react';
import { noop } from 'underscore';

import { JACKPOT_UPDATE_INTERVAL_TIME } from '../constants';

const jackpots: Map<string, () => void> = new Map();
let lastRequestId = 0;
let intervalId: ReturnType<typeof setInterval> | undefined;

export const useJackpotUpdateFrame = (id: string, updateFn: () => void) => {
    useEffect(() => {
        if (id) {
            jackpots.set(id, updateFn);
        }

        return () => {
            jackpots.delete(id);
        };
    }, [updateFn, id]);

    useEffect(() => {
        clearInterval(intervalId);

        if (jackpots.size) {
            intervalId = setInterval(() => {
                cancelAnimationFrame(lastRequestId);

                jackpots.forEach((fn) => {
                    fn();
                });

                lastRequestId = requestAnimationFrame(noop);
            }, JACKPOT_UPDATE_INTERVAL_TIME);
        }
    }, [id]);
};
